import { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useDispatch, useSelector, useStore } from 'react-redux'
import _ from 'lodash'
import { sify } from 'chinese-conv'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Allotment } from 'allotment'
import 'allotment/dist/style.css'
import { constants as cons, TABLE_TYPE_DEFAULT_VALUE } from '../../Constants/constants'
import { getOne as newGetOne, newPut } from '../../helper/baseFetch_v2'
import { getOne, put } from '../../helper/baseFetch'
import {
    setQueueTemplate,
    setQueueTemplateTimeSectionValue,
    setQueueTemplateTableTypeValue,
    setQueueTemplateTableTypeColorList,
    setQueueTemplateDefaultTableTypeColorList,
} from '../../actions/queueTemplateAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { TempTextInput } from '../../Component/Input/TempTextInput'
import { QueueTemplateTimeSection } from './QueueTemplateTimeSection'
import { QueueTemplateTimeSectionList } from './QueueTemplateTimeSectionList'
import { QueueTemplateTableType } from './QueueTemplateTableType'
import QueueTemplateValidation from '../../validations/queueTemplateValidation'
import { GlobalDialog } from '../../Component/GlobalDialog'
import {
    getIsSyncMapForSessionDateField,
    getIsSyncMapForRequestTicketTimeFields,
    getIsSyncMapForStartAndEndTimeFields,
} from './queueTemplateUtil'
import { QueueTemplateGroupedSection } from './QueueTemplateGroupedSection'
import { getTableTypeBackgroundColor, getTableTypeForegroundColor } from '../../helper/util'
import useRestaurant from '../../hooks/Restaurant/useRestaurant'
import moment from 'moment'

import StatusLabel from '../../Component/_v2/label/StatusChip'

export const QueueTemplateEdit = () => {
    const dispatch = useDispatch()
    const store = useStore()
    const params = useParams()
    const history = useHistory()
    const [ready, setReady] = useState(false)
    const [clear, setClear] = useState(true)
    const savedQueueTemplate = useSelector((state) => state.queueTemplate.ui.queueTemplate)

    const [restUrlId, setRestUrlId] = useState(null)
    const [queueTemplateInputList, setQueueTemplateInputList] = useState({
        templateCode: '',
        description: '',
        status: '',
    })
    const [customIdNumber, setCustomIdNumber] = useState(0)
    const [selectedType, setSelectedType] = useState('')
    const [dialog, setDialog] = useState({
        open: false,
        dialogActions: [],
    })
    // eslint-disable-next-line no-unused-vars
    const [errorVersion, setErrorVersion] = useState(QueueTemplateValidation.getVersion())
    const [soundVoiceList, setSoundVoiceList] = useState([])

    const resource = 'QueueTemplate'

    const tabs = [
        {
            label: { resource: resource, key: 'info' },
            tabIndex: cons.QUEUE_TEMPLATE_TAB.INFO,
        },
    ]

    const tabContents = [
        {
            tab: (
                <>
                    <div>
                        <TempTextInput
                            inputSetting={{
                                className: 'edit-create-input',
                                variant: cons.STYLE.VARIANT.STANDARD,
                                size: cons.SIZE.SMALL,
                                label: { resource: resource, key: 'templateCode' },
                                value: queueTemplateInputList.templateCode,
                                name: 'templateCode',
                                multiline: true,
                                disabled: true,
                            }}
                            handleChange={onChangeDescription}
                        />
                        <TempTextInput
                            inputSetting={{
                                className: 'edit-create-input',
                                size: cons.SIZE.SMALL,
                                label: { resource: resource, key: 'description' },
                                value: queueTemplateInputList.description,
                                name: 'description',
                                multiline: true,
                                helperTextIcon: true,
                                helperText: QueueTemplateValidation.getErrorMessages('description'),
                            }}
                            handleChange={onChangeDescription}
                        />
                    </div>
                    <Allotment defaultSizes={[100, 200]}>
                        <QueueTemplateTimeSectionList
                            resource={resource}
                            setSelectedType={setSelectedType}
                            setCustomIdNumber={setCustomIdNumber}
                            customIdNumber={customIdNumber}
                        />
                        <div className='queue-template-flex-right'>
                            {selectedType === 'timeSection' ? (
                                <QueueTemplateTimeSection
                                    setCustomIdNumber={setCustomIdNumber}
                                    customIdNumber={customIdNumber}
                                />
                            ) : selectedType === 'tableType' ? (
                                <QueueTemplateTableType
                                    setCustomIdNumber={setCustomIdNumber}
                                    customIdNumber={customIdNumber}
                                    soundVoiceList={soundVoiceList}
                                />
                            ) : selectedType === 'groupedSection' ? (
                                <QueueTemplateGroupedSection />
                            ) : (
                                <></>
                            )}
                        </div>
                    </Allotment>
                </>
            ),
            btn: true,
        },
    ]

    const bottomButtons = [
        {
            variant: cons.STYLE.VARIANT.CONTAINED,
            color: cons.STYLE.PRIMARY,
            label: { key: 'save' },
            onClick: onClickSave,
            className: 'margin-left-16',
            icon: <SaveIcon />,
            disabled: !savedQueueTemplate || savedQueueTemplate.length === 0,
        },
        {
            variant: cons.STYLE.VARIANT.CONTAINED,
            color: cons.STYLE.PRIMARY,
            label: { key: 'clear' },
            disabled: false,
            onClick: onClickClear,
            className: 'margin-left-16',
            icon: <ClearIcon />,
        },
        ...(queueTemplateInputList.status === 'A'
                ? [
                    {
                        variant: cons.STYLE.VARIANT.CONTAINED,
                        color: cons.STYLE.PRIMARY,
                        label: { key: 'deactive' },
                        onClick: () => onClickUpdateStatus('D'),
                        className: 'special-button special-button-margin-left error',
                    },
                ]
                : []),
        ...(queueTemplateInputList.status === 'D'
                ? [
                    {
                        variant: cons.STYLE.VARIANT.CONTAINED,
                        color: cons.STYLE.PRIMARY,
                        label: { key: 'active' },
                        onClick: () => onClickUpdateStatus('A'),
                        className: 'special-button special-button-margin-left success',
                    },
                ]
                : []),
    ]

    function onChangeDescription(name, e) {
        let newQueueTemplateInputList = _.cloneDeep(queueTemplateInputList)
        newQueueTemplateInputList.description = e
        setQueueTemplateInputList(newQueueTemplateInputList)
    }

    function onClickUpdateStatus(status) {
        newPut({
            path: 'gulu-console/shop/queue/queue-template/' + params.id + '/status',
            body: {
                status: status,
            },
            successCallback: () => {
                setQueueTemplateInputList((prev) => ({
                    ...prev,
                    status: status,
                }))
                setDialog({
                    open: true,
                    onClose: onClickBackToEdit,
                    dialogContentText: { key: 'editSuccess' },
                    maxWidth: 'md',
                    dialogActions: [
                        {
                            label: { key: 'backEdit' },
                            onClick: onClickBackToEdit,
                            icon: <ArrowBackIcon />,
                        },
                        {
                            label: { key: 'backList' },
                            onClick: onClickBackToList,
                            icon: <LowPriorityIcon />,
                        },
                    ],
                })
            },
            store: store,
        })
    }

    const onClickBackToEdit = () => {
        setDialog({
            open: false,
            dialogActions: [],
        })
        onClickClear()
    }

    const onClickBackToList = () => {
        setDialog({
            open: false,
            dialogActions: [],
        })
        history.push(
            '/' +
                cons.PATH.SHOP.SYSTEM_GROUP_RESTAURANT +
                '/' +
                restUrlId +
                '/' +
                cons.RESTAURANT_TAB.QUEUE +
                '/' +
                cons.RESTAURANT_QUEUE_SUB_TAB.QUEUE_TEMPLATE
        )
    }

    function onClickSave() {
        QueueTemplateValidation.validateTemplate(
            savedQueueTemplate,
            queueTemplateInputList.description
        )

        if (QueueTemplateValidation.isValid()) {
            let clonedSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
            let newTableTypeList = []

            clonedSavedQueueTemplate.forEach((timeSection) => {
                let clonedTableTypeList = _.cloneDeep(timeSection.tableTypeList, timeSection)
                let newTableTypeListIdx = clonedTableTypeList.length - 1
                delete timeSection.id
                delete timeSection.status
                delete timeSection.tableTypeList
                delete timeSection.sessionDate
                delete timeSection.endTime
                delete timeSection.startTime
                delete timeSection.kioskRequestTicketStartTime
                delete timeSection.kioskRequestTicketEndTime
                delete timeSection.mobileRequestTicketStartTime
                delete timeSection.mobileRequestTicketEndTime
                delete timeSection.description
                clonedTableTypeList.forEach((clonedTableType) =>
                    newTableTypeList.push(
                        Object.assign(
                            { ...clonedTableType, displaySequence: newTableTypeListIdx-- * 10 },
                            timeSection
                        )
                    )
                )
            })

            newPut({
                path: 'gulu-console/shop/queue/queue-template' + '/' + params.id,
                body: {
                    description: queueTemplateInputList.description,
                    timeSectionList: newTableTypeList,
                },
                successCallback: () => {
                    setDialog({
                        open: true,
                        onClose: onClickBackToEdit,
                        dialogContentText: { key: 'editSuccess' },
                        maxWidth: 'md',
                        dialogActions: [
                            {
                                label: { key: 'backEdit' },
                                onClick: onClickBackToEdit,
                                icon: <ArrowBackIcon />,
                            },
                            {
                                label: { key: 'backList' },
                                onClick: onClickBackToList,
                                icon: <LowPriorityIcon />,
                            },
                        ],
                    })
                    setClear(false)
                },
                store: store
            })

            // put(
            //     cons.PATH.SHOP.QUEUE.QUEUE_TEMPLATE + '/' + params.id,
            //     {
            //         restUrlId: restUrlId,
            //         description: queueTemplateInputList.description,
            //         status: queueTemplateInputList.status,
            //         timeSectionList: newTableTypeList,
            //     },
            //     () => {
            //         setDialog({
            //             open: true,
            //             onClose: onClickBackToEdit,
            //             dialogContentText: { key: 'editSuccess' },
            //             maxWidth: 'md',
            //             dialogActions: [
            //                 {
            //                     label: { key: 'backEdit' },
            //                     onClick: onClickBackToEdit,
            //                     icon: <ArrowBackIcon />,
            //                 },
            //                 {
            //                     label: { key: 'backList' },
            //                     onClick: onClickBackToList,
            //                     icon: <LowPriorityIcon />,
            //                 },
            //             ],
            //         })
            //         setClear(false)
            //     },
            //     undefined,
            //     store
            // )
            // QueueTemplateValidation.resetErrorMessages()
        } else {
            setErrorVersion(QueueTemplateValidation.getVersion())
        }
    }

    function onClickClear() {
        setClear(true)
    }

    /**
     * Automatically calculates and sets the 'disable' translation flags on an object.
     * @param {Object} targetObj - The object to modify (e.g., originalTableType)
     * @param {Array<string>} paths - Array of paths to check (e.g., ['tableType.kioskLabel', ...])
     */
    function initDisableFields(targetObj, paths) {
        if (!targetObj || !Array.isArray(paths)) return;

        paths.forEach((path) => {
            // 1. Safely extract the zh-HK and zh-CN values using Lodash
            const hkValue = _.get(targetObj, `${path}.zh-HK`);
            const cnValue = _.get(targetObj, `${path}.zh-CN`);

            // 2. Evaluate your core i18n logic
            const isBothEmpty = !hkValue && !cnValue;
            const isMatchingSify = hkValue && sify(hkValue) === cnValue;
            const shouldDisable = isBothEmpty || isMatchingSify;

            // 3. Generate the dynamic flag field name
            // Splits the path, drops the first root folder segment, camel-cases the rest
            const pathParts = path.split('.');
            const remainingSegments = pathParts.slice(0);
            
            const camelCasedName = remainingSegments
            .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
            .join('');

            const toggleFieldName = `disable${camelCasedName}`;
            // console.log(toggleFieldName, !!shouldDisable)

            // 4. Assign the boolean flag back to the root level of your object
            targetObj[toggleFieldName] = !!shouldDisable;
        });
    }

    useEffect(() => {
        dispatch(setQueueTemplate(cons.QUEUE_TEMPLATE_INPUT_LIST))
        QueueTemplateValidation.resetErrorMessages()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // TODO: useEffect part need refactor to be more readable, naming of variables and functions to be more descriptive
    useEffect(() => {
        if (clear === true) {

            newGetOne(
                'gulu-console/shop/queue/queue-template' + '/' + params.id,
                undefined,
                (payload) => {
                    setQueueTemplateInputList({
                        templateCode: payload.templateCode,
                        description: payload.description,
                        status: payload.status,
                    })
                    setRestUrlId(payload.restUrlId)
                    dispatch(setQueueTemplateTableTypeColorList(payload.tableTypeColorConfigList))
                    dispatch(
                        setQueueTemplateDefaultTableTypeColorList(
                            payload.defaultTableTypeColorConfigList
                        )
                    )

                    let originalTimeSectionList = _.cloneDeep(payload.timeSectionList)
                    let newTimeSectionList = []

                    /* A map that store all table types
                    in the same time section: Boolean checked whether
                    the time related fields are same as the parent
                    time section ↓↓↓*/
                    const isSyncMapForSessionDateField =
                        getIsSyncMapForSessionDateField(originalTimeSectionList)
                    const isSyncMapForStartAndEndTimeFields =
                        getIsSyncMapForStartAndEndTimeFields(originalTimeSectionList)
                    const isSyncMapForRequestTicketTimeFields =
                        getIsSyncMapForRequestTicketTimeFields(originalTimeSectionList)

                    const targetFields = [
                        'tableType.kioskLabel', 
                        'tableType.mobileLabel', 
                        'groupedSection.label',
                        'groupedSection.description',
                        'tableType.ticketLabel',
                        'ticketType.label',
                    ];

                    originalTimeSectionList.forEach((originalTableType) => {
                        if (
                            newTimeSectionList.length > 0 &&
                            newTimeSectionList
                                .map((t) => {
                                    return t.timeSectionId
                                })
                                .includes(originalTableType.timeSectionId)
                        ) {
                            newTimeSectionList.forEach((newTableType) => {
                                if (
                                    newTableType.timeSectionId === originalTableType.timeSectionId
                                ) {
                                    initDisableFields(originalTableType, targetFields)

                                    originalTableType.customId = originalTableType.id
                                    originalTableType.timeSectionCustomId = newTableType.id

                                    originalTableType.displayTableTypeForegroundColor =
                                        getTableTypeForegroundColor(
                                            originalTableType.tableTypeForegroundColor,
                                            newTableType.tableTypeList?.length
                                                ? newTableType.tableTypeList.length
                                                : 0,
                                            payload.tableTypeColorConfigList ||
                                                payload.defaultTableTypeColorConfigList
                                        )

                                    originalTableType.displayTableTypeBackgroundColor =
                                        getTableTypeBackgroundColor(
                                            originalTableType.tableTypeBackgroundColor,
                                            newTableType.tableTypeList?.length
                                                ? newTableType.tableTypeList.length
                                                : 0,
                                            +payload.tableTypeColorConfigList ||
                                                payload.defaultTableTypeColorConfigList
                                        )

                                    

                                    if (typeof originalTableType.cutOffMinute === 'number') {
                                        const today = moment()
                                        const split = originalTableType.startTime.split(':')

                                        const startTimeMoment = today.set({
                                            hour: split[0],
                                            minute: split[1],
                                            second: split[2],
                                        })

                                        originalTableType.cutOffTime = startTimeMoment
                                            .subtract(originalTableType.cutOffMinute, 'minutes')
                                            .format('HH:mm:ss')
                                    } else {
                                        originalTableType.cutOffTime = null
                                    }

                                    newTableType.tableTypeList.push(originalTableType)
                                }
                            })
                        } else {
                            initDisableFields(originalTableType, targetFields)

                            originalTableType.customId = originalTableType.id
                            originalTableType.timeSectionCustomId = originalTableType.id

                            originalTableType.displayTableTypeForegroundColor =
                                getTableTypeForegroundColor(
                                    originalTableType.tableTypeForegroundColor,
                                    0,
                                    payload.tableTypeColorConfigList ||
                                        payload.defaultTableTypeColorConfigList
                                )

                            originalTableType.displayTableTypeBackgroundColor =
                                getTableTypeBackgroundColor(
                                    originalTableType.tableTypeBackgroundColor,
                                    0,
                                    payload.tableTypeColorConfigList ||
                                        payload.defaultTableTypeColorConfigList
                                )

                            if (typeof originalTableType.cutOffMinute === 'number') {
                                const today = moment()
                                const split = originalTableType.startTime.split(':')

                                const startTimeMoment = today.set({
                                    hour: split[0],
                                    minute: split[1],
                                    second: split[2],
                                })

                                originalTableType.cutOffTime = startTimeMoment
                                    .subtract(originalTableType.cutOffMinute, 'minutes')
                                    .format('HH:mm:ss')
                            } else {
                                originalTableType.cutOffTime = null
                            }

                            const isSyncSessionDateField =
                                isSyncMapForSessionDateField.get(
                                    originalTableType.timeSectionId
                                )

                            const isSyncStartAndEndTimeFields =
                                isSyncMapForStartAndEndTimeFields.get(
                                    originalTableType.timeSectionId
                                )
                            const isSyncRequestTicketTimeFields =
                                isSyncMapForRequestTicketTimeFields.get(
                                    originalTableType.timeSectionId
                                )

                            newTimeSectionList.push({
                                id: originalTableType.id,
                                customId: originalTableType.id,
                                templateCode: originalTableType.templateCode,
                                timeSectionId: originalTableType.timeSectionId,
                                // timeSectionTcLabel: originalTableType.label?.['zh-HK'],
                                // timeSectionEnLabel: originalTableType.label?.en,
                                // timeSectionScLabel: originalTableType.label?.['zh-CN'],
                                label: originalTableType?.label,
                                // disableLabel: originalTableType.disableLabel,
                                disableLabel: originalTableType?.label?.['zh-HK'] === originalTableType?.label?.['zh-CN'],
                                isSyncSessionDateWithAllTableTypes: isSyncSessionDateField || false,
                                sessionDate: isSyncSessionDateField
                                    ? originalTableType.sessionDate
                                    : null,
                                isSyncTimeFieldsWithAllTableTypes:
                                    isSyncStartAndEndTimeFields || false,
                                isSyncRequestTicketTimeFieldsWithAllTableTypes:
                                    isSyncRequestTicketTimeFields || false,
                                startTime: isSyncStartAndEndTimeFields
                                    ? originalTableType.startTime
                                    : null,
                                endTime: isSyncStartAndEndTimeFields
                                    ? originalTableType.endTime
                                    : null,
                                description: isSyncStartAndEndTimeFields
                                    ? originalTableType?.description
                                    : '',
                                kioskRequestTicketStartTime: isSyncRequestTicketTimeFields
                                    ? originalTableType.kioskRequestTicketStartTime
                                    : null,
                                kioskRequestTicketEndTime: isSyncRequestTicketTimeFields
                                    ? originalTableType.kioskRequestTicketEndTime
                                    : null,
                                mobileRequestTicketStartTime: isSyncRequestTicketTimeFields
                                    ? originalTableType.mobileRequestTicketStartTime
                                    : null,
                                mobileRequestTicketEndTime: isSyncRequestTicketTimeFields
                                    ? originalTableType.mobileRequestTicketEndTime
                                    : null,
                                status: 'A',
                                mobileIcon: originalTableType.mobileIcon,
                                kioskIcon: originalTableType.kioskIcon,
                                tableTypeList: [originalTableType],
                            })
                        }
                    })

                    dispatch(setQueueTemplate(newTimeSectionList))
                    dispatch(setQueueTemplateTimeSectionValue(cons.TIME_SECTION_DEFAULT_VALUE))
                    dispatch(setQueueTemplateTableTypeValue(TABLE_TYPE_DEFAULT_VALUE))
                    setSelectedType('')

                    getOne(
                        cons.PATH.MERCHANT.SOUND_INFO_VOICE,
                        undefined,
                        (payload) => {
                            setSoundVoiceList(
                                payload.map((soundVoice) => ({
                                    name: soundVoice.name,
                                    value: soundVoice.code,
                                }))
                            )
                        },
                        undefined,
                        store
                    )

                    setReady(true)
                    setClear(false)
                },
                undefined,
                store
        )
        }
    }, [clear]) // eslint-disable-line react-hooks/exhaustive-deps

    const { getRestaurantIdAndName } = useRestaurant(restUrlId)
    const mapCode = getRestaurantIdAndName()

    // useEffect(() => {
    //   console.log('savedQueueTemplate', savedQueueTemplate)
    // }, [savedQueueTemplate])

    return (
        ready && (
            <>
                <EditCreateDisplay
                    code={savedQueueTemplate && savedQueueTemplate.id ? savedQueueTemplate.id : ''}
                    resource={resource}
                    tabs={tabs}
                    content={tabContents}
                    bottomBtns={bottomButtons}
                    mapName={{ resource: 'restaurant', key: 'restUrlId' }}
                    mapCode={mapCode}
                    status={queueTemplateInputList.status}
                    display='edit'
                />
                {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
            </>
        )
    )
}
